export default {"src":"/login-app/[GIT_HASH]/_next/static/media/definition.669ba1dc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};